import InputField from "components/styledFormElements/InputField"
import { useFormContext } from "react-hook-form"

const SharedTemplateConfig = () => {
    const {
        register,
        formState: { errors },
    } = useFormContext<any>()

    const shareErrors = errors.share as any

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <InputField
                    label="App Share Template"
                    type="text"
                    required
                    register={register("share.app_share_template", {
                        required: "App share template is required",
                    })}
                    error={shareErrors?.app_share_template?.message as string}
                />
                <InputField
                    label="Episode Share Template"
                    type="text"
                    required
                    register={register("share.episode_share_template", {
                        required: "Episode share template is required",
                    })}
                    error={shareErrors?.episode_share_template?.message as string}
                />
                <InputField
                    label="PDF Share Template"
                    type="text"
                    required
                    register={register("share.pdf_share_template", {
                        required: "PDF share template is required",
                    })}
                    error={shareErrors?.pdf_share_template?.message as string}
                />
            </div>
        </div>
    )
}

export default SharedTemplateConfig
